import React from 'react';

/*
  Note: anf-core/anf-core-react v7.107.1 removed IconText, so this will act as a
  intermediary component to handle rendering icons. Have spoken to Luke about introducing
  an Icon component.
  Since the spinner icon is not yet available in the DS, we're retaining this implementation for now
*/
export default function Icon() {
  return (
    <span
      className="spin-container"
      data-hidden={false}
      data-state="processing"
      aria-hidden="true"
      data-testid="icon"
    >
      <span className="spinner" data-testid="spinner" />
    </span>
  );
}
